








































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({})
export default class NPS extends Vue {
  /* eslint-disable no-console */
  /*Variables globales*/
  private idClubPetco: any;
  private origenValor = 2; // Grooming
  private tipoValor = '';
  private mensajeGlobal = '';
  private validacion = [(v: any) => v <= 6 || 'Only 80 in stock'];
  private comentarioValor = '';
  private opciones = [];
  form_submitting = false;
  // Circulo de carga
  private overlay = false;
  // SnackBar
  private snackbar = false;
  private text = '';
  private type = '';
  private timeout = 4500;
  // Variable componente Raiting 
  private emptyIcon = 'mdi-paw';
  private fullIcon = 'mdi-paw';
  private halfIcon = 'mdi-paw-half-full';
  private colorIcon = '#FFC100'
  private imageValor = require('../assets/imagenes/NPS_corgi_7-8.png')
  private raitingValor = 7;
  private valorColorIcon = '';
  private valorPregunta = '¡ Hola ' +this.capitalizeOnlyFirst(this.$store.getters.nombreCliente) +'!';
  // Dialog
  private dialogSuccess = false;
  private imgDialog = require('../assets/imagenes/success_dog.png');
  private textDialog = '';
  private dialogCalificacion: boolean = false;
  private dialogCalificacionComment: boolean = false;
  private urlToRedirect = this.$store.getters.paisCliente == 'CL' ? 'https://petco.cl' : 'https://petco.com.mx'; 

  //Mailer
  private mailer = {
    id: this.$store.getters.idUser,
    text: this.$store.getters.comentarioInsertado,
    idnps: 2 //esta hay que settear por nps id
  }

  private redirect = 'https://www.petco.com.mx';
  private get nombreTienda(){
    if (this.$store.getters.nombreTienda.length > 0) { 
      return "Grooming Salon " +this.$store.getters.nombreTienda
    } else {
      return "Grooming Salon"
    }
  }
  /* Capitalize  */
  private capitalizeOnlyFirst(palabra: any) {
      return palabra.charAt(0).toUpperCase() +palabra.slice(1).toLowerCase();
  }


  /* Métodos */
  private getValorPregunta() {
    let puntaje = this.$store.getters.puntaje;
    let nombreUsuario = this.capitalizeOnlyFirst(this.$store.getters.nombreCliente);
    if (this.isDefined(puntaje)) {
      if (puntaje <= 6) {
        if (puntaje === 1) {
          this.valorPregunta = nombreUsuario + ' por favor envíanos información sobre lo ocurrido para atenderte de inmediato';
        } else if (puntaje === 2 || puntaje === 3) {
          this.valorPregunta = nombreUsuario + ' por favor envíanos más información sobre lo ocurrido para que podamos contactarte a la brevedad';
        } else if (puntaje === 4 || puntaje === 5) {
          this.valorPregunta = nombreUsuario + ' por favor envíanos tus comentarios para poder darte una solución lo antes posible';
        } else if (puntaje === 6) {
          this.valorPregunta = 'Gracias ' + nombreUsuario + ', por favor envíanos tus comentarios, estos son importantes para que podamos mejorar';
        } else {
          this.valorPregunta = '¿Por qué no lo recomendarías?';
        }
        this.imageValor = require('../assets/imagenes/NPS_corgi_dislike.png');
      } else if (puntaje >= 7 && puntaje < 9) {
        this.valorPregunta = '¡Gracias ' + nombreUsuario + '! ¿Hay algo que podamos hacer para mejorar tu experiencia?';
        this.textDialog = 'Hemos recibido tu mensaje, lo enviaremos con el equipo encargado para trabajar esta oportunidad'
        this.imageValor = require('../assets/imagenes/NPS_corgi_7-8.png');
      } else if (puntaje >= 9) {
        this.valorPregunta = '¡Gracias ' + nombreUsuario + '! ¿Hay algo más que te gustaría que hiciéramos por ti?';
        this.textDialog = 'Hemos recibido tu mensaje ¡Esperamos verte pronto!'
        this.imageValor = require('../assets/imagenes/In_Love.png');
      } else {
        this.valorPregunta = '¡ Hola !';
        this.imageValor = require('../assets/imagenes/NPS_corgi_7-8.png');
      }
    }
  }

  private isDefined(param: any) {
    return param !== null && param !== undefined && param !== '';
  }

  private created() {
    if (this.isDefined(this.$store.getters.comentarioInsertado)) {
      this.comentarioValor = this.$store.getters.comentarioInsertado;
    }
    if (this.isDefined(this.$store.getters.puntaje)) {
      this.raitingValor = this.$store.getters.puntaje + 1;
    }
    if(this.raitingValor <= 6) {     
      this.tipoValor = 'NEG';
    } else if(this.raitingValor >= 7 && this.raitingValor < 9) {
      this.tipoValor = 'NEU';
    } else if(this.raitingValor >= 9) {
      this.tipoValor = 'POS';
    } 
    this.getValorPregunta();

  }

  // Metodo inserta comentario proporcionado por el cliente
  private insertaComentario() {
    if (this.raitingValor === 0) {
      this.dialogCalificacion = true;
      return;

    }else if(this.raitingValor -1 <= 8 && this.comentarioValor.trim() === '') {
      this.dialogCalificacionComment = true;
      return;
    }
    
    this.overlay = true;
    let nombreMetodo = '';
    let data = {};
      if (this.comentarioValor.trim() !== '' || this.comentarioValor.trim() === '') {
        this.form_submitting = true;
        data = {
          idClubPetco: this.$store.getters.idUser,
          ratingValor: this.raitingValor - 1,
          origenValor: this.origenValor,
          tipoValor: this.tipoValor,
          comentarioValor: this.comentarioValor,
          tiendaValor: this.isDefined(this.$store.getters.idTienda) ? this.$store.getters.idTienda : '7501',
          idCitaGrooming: this.isDefined(this.$store.getters.idCita) ? this.$store.getters.idCita : null,
          idEmpleado: this.isDefined(this.$store.getters.idEmpleado) ? this.$store.getters.idEmpleado : null,
          idUnico: this.isDefined(this.$store.getters.idUnico) ? this.$store.getters.idUnico : null       
        }
        this.$store.dispatch('GuardaComentario', data)
        .then ((respuesta) => {
          if (respuesta) {
            this.form_submitting = false;
            this.$store.commit('idComentarioInsertado', respuesta.insertId); 
            this.$store.commit('comentarioInsertado', this.comentarioValor);
            this.$store.commit('puntaje', this.raitingValor - 1);
            this.dialogSuccess = true;
            this.overlay = false;
              if (this.isDefined(respuesta.name) && respuesta.name === 'Error') {
                this.createSnackBar('Error al procesar tu solicitud, intenta más tarde', 'error');
                this.dialogSuccess = true;
                //window.location.href = 'https://petco.com.mx';              
              } else {
                if (this.isDefined(respuesta.duplicate) && respuesta.duplicate === true) {
                  this.createSnackBar('Ya has contestado con anterioridad esta encuesta', 'warning');
                  this.dialogSuccess = false;
                  return;
                }
                  //AQUI ES EL MAILER
                  this.mailer.text = this.comentarioValor;
                  this.$store.commit('preguntas', respuesta);
                  if (respuesta.clave1 == '299-299201') {
                    //this.$store.dispatch('EmailSend', this.mailer);
                    this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
                    this.dialogSuccess = true;
                    if (this.$router.currentRoute.path === '/grooming/'+this.$store.getters.idUser) { 
                      this.$store.dispatch('LimpiaStateTienda'); // Limpieza de store.
                      this.redirect = "https://nps.petco.com.mx/grooming/"+this.$store.getters.idUser
                    } else {
                      this.$store.dispatch('LimpiaState'); // Limpieza de store.
                    }                  
                  } else if (respuesta.clave1 == '99-998') {
                      // this.$store.dispatch('EmailSend', this.mailer);
                      this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
                      this.dialogSuccess = true;
                      if (this.$router.currentRoute.path === '/grooming/'+this.$store.getters.idUser) { 
                        this.$store.dispatch('LimpiaStateTienda'); // Limpieza de store.
                        this.redirect = "https://nps.petco.com.mx/grooming/"+this.$store.getters.idUser
                      } else {
                        this.$store.dispatch('LimpiaState'); // Limpieza de store.
                      }  
                  } else if (respuesta.clave1 == '99-997') {
                      // this.$store.dispatch('EmailSend', this.mailer);
                      this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
                      this.dialogSuccess = true;
                      if (this.$router.currentRoute.path === '/grooming/'+this.$store.getters.idUser) { 
                        this.$store.dispatch('LimpiaStateTienda'); // Limpieza de store.
                        this.redirect = "https://nps.petco.com.mx/grooming/"+this.$store.getters.idUser
                      } else {
                        this.$store.dispatch('LimpiaState'); // Limpieza de store.
                      }                    
                  } else if (respuesta.clave1 == '99-996') {
                    // this.$store.dispatch('EmailSend', this.mailer);
                    this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
                    this.dialogSuccess = true;
                    if (this.$router.currentRoute.path === '/grooming/'+this.$store.getters.idUser) { 
                      this.$store.dispatch('LimpiaStateTienda'); // Limpieza de store.
                      this.redirect = "https://nps.petco.com.mx/grooming/"+this.$store.getters.idUser
                    } else {
                      this.$store.dispatch('LimpiaState'); // Limpieza de store.
                    }                    
                  } else if (respuesta.clave1 == '298-298201'|| respuesta.clave1 == '44998-44444998' || respuesta.clave1.includes('998')) {
                      this.textDialog = respuesta.respuesta !== '' ? respuesta.respuesta : 
                      'Hemos recibido tu mensaje ¡Esperamos verte pronto!';
                      this.dialogSuccess = true;
                      if (this.$router.currentRoute.path === '/grooming/'+this.$store.getters.idUser) { 
                        this.$store.dispatch('LimpiaStateTienda'); // Limpieza de store.
                        this.redirect = "https://nps.petco.com.mx/grooming/"+this.$store.getters.idUser
                      } else {
                          this.$store.dispatch('LimpiaState'); // Limpieza de store.
                      }                      
                      // setTimeout(() => {
                      //   if (this.$router.currentRoute.path === '/grooming/'+this.$store.getters.idUser) {
                      //     window.location.href = 'https://nps.petco.com.mx/grooming/'+this.$store.getters.idUser;
                      //   } else {
                      //     window.location.href = 'https://petco.com.mx';
                      //   }
                      // }, 4500);
                  } else if (respuesta.clave1 == '297-297201' || respuesta.clave1 == '296-296201' || respuesta.clave1 == '44997-44444997'|| respuesta.clave1 == '44996-44444996') {
                      this.textDialog = 'Hemos recibido tu mensaje, lo enviaremos con el equipo encargado para trabajar esta oportunidad'
                      this.dialogSuccess = true;
                      if (this.$router.currentRoute.path === '/grooming/'+this.$store.getters.idUser) { 
                        this.$store.dispatch('LimpiaStateTienda'); // Limpieza de store.
                        this.redirect = "https://nps.petco.com.mx/grooming/"+this.$store.getters.idUser
                      } else {
                        this.$store.dispatch('LimpiaState'); // Limpieza de store.
                      }                      
                      setTimeout(() => {
                        if (this.$router.currentRoute.path === '/grooming/'+this.$store.getters.idUser) {
                          window.location.href = 'https://nps.petco.com.mx/grooming/'+this.$store.getters.idUser;
                        } else {
                          window.location.href = 'https://petco.com.mx';
                        }
                      }, 4500);
                  } else if (respuesta.clave1 == '5-4') {
                      this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
                      this.dialogSuccess = true;
                      if (this.$router.currentRoute.path === '/grooming/'+this.$store.getters.idUser) { 
                        this.$store.dispatch('LimpiaStateTienda'); // Limpieza de store.
                        this.redirect = "https://nps.petco.com.mx/grooming/"+this.$store.getters.idUser
                      } else {
                        this.$store.dispatch('LimpiaState'); // Limpieza de store.
                      }                     
                  } else {
                      this.textDialog = 'Hemos recibido tu mensaje, lo enviaremos con el equipo encargado para trabajar esta oportunidad'
                      this.dialogSuccess = true;
                  }
              }
          }
        })  
        .catch ((error) => {});  
      } else { // Sin comentario
          this.dialogSuccess = true;
          if (this.$router.currentRoute.path === '/grooming/'+this.$store.getters.idUser) { 
                        this.$store.dispatch('LimpiaStateTienda'); // Limpieza de store.
                        this.redirect = "https://nps.petco.com.mx/grooming/"+this.$store.getters.idUser
          } else {
            this.$store.dispatch('LimpiaState'); // Limpieza de store.
          }        
          setTimeout(() => {
            if (this.$router.currentRoute.path === '/grooming/'+this.$store.getters.idUser) {
              window.location.href = 'https://nps.petco.com.mx/grooming/'+this.$store.getters.idUser;
            } else {
              window.location.href = 'https://petco.com.mx';
            }
          }, 4500);
      }
  }

  private createSnackBar (text: string, type: string) {
    this.snackbar = true;
    this.text = text;
    this.type = type;
  }

  private comentarioPuntuacion(rate: any) { 
    this.raitingValor = rate;
    this.validaValorRaiting()
    let nombreUsuario = this.capitalizeOnlyFirst(this.$store.getters.nombreCliente);
    let rating = this.raitingValor - 1;
    if(rating <= 6) {
      if (rating === 1) {
        this.valorPregunta = nombreUsuario + ' por favor envíanos información sobre lo ocurrido para atenderte de inmediato';
      } else if (rating === 2 || rating === 3) {
        this.valorPregunta = nombreUsuario + ' por favor envíanos más información sobre lo ocurrido para que podamos contactarte a la brevedad';
      } else if (rating === 4 || rating === 5) {
        this.valorPregunta = nombreUsuario + ' por favor envíanos tus comentarios para poder darte una solución lo antes posible';
      } else if (rating === 6) {
        this.valorPregunta = 'Gracias '+ nombreUsuario + ', por favor envíanos tus comentarios, estos son importantes para que podamos mejorar';
      } else {
        this.valorPregunta = '¿Por qué no lo recomendarías?';
      }
      this.colorIcon = 'red'
      this.valorColorIcon = 'red';
      this.tipoValor = 'NEG';
      this.imageValor = require('../assets/imagenes/NPS_corgi_dislike.png');
    } else if(rating >= 7 && rating < 9) {
      this.colorIcon = '#FFC100';
      this.valorColorIcon = 'green';
      this.valorPregunta = '¡Gracias '+ nombreUsuario + '! ¿Hay algo que podamos hacer para mejorar tu experiencia?';
      this.textDialog = 'Hemos recibido tu mensaje, lo enviaremos con el equipo encargado para trabajar esta oportunidad'
      this.tipoValor = 'NEU';
      this.imageValor = require('../assets/imagenes/NPS_corgi_7-8.png');
    } else if(rating === 9 || rating === 10 ) {
      this.colorIcon = 'blue';
      this.valorColorIcon = 'green';
      this.valorPregunta = '¡Gracias '+ nombreUsuario + '! ¿Hay algo más que te gustaría que hiciéramos por ti?';
      this.textDialog = 'Hemos recibido tu mensaje ¡Esperamos verte pronto!'
      this.tipoValor = 'POS';
      this.imageValor = require('../assets/imagenes/In_Love.png');
    } 
  }

  // Valida si se recibieron preguntas para el usuario
  private validaPreguntas (array: any) {
    if (array.preguntas1.length > 0 || array.preguntas2.length > 0 || array.preguntas3.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  // Valida valor de puntaje para limitarlo de cero a diez
  private validaValorRaiting() {
    if (this.raitingValor >= 11) {
      this.raitingValor = 11;
    } else if (this.raitingValor < 0 ) {
      this.raitingValor = 0;
    }  
  }
}
